import React from "react";
import {
    Card,
    CardHeader,
    CardBody,
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,

} from "@material-tailwind/react";

import logo_h from './../../assets/images/logo_h.jpeg'
import login_bg from './../../assets/images/login_bg.jpg'
import { ToastContainer, toast } from 'react-toastify';
import { Navigate } from "react-router-dom";
import Login from "../../components/auth/Login";
import Register from "../../components/auth/Register";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useShared } from "../../hooks/useShared";

export default function AuthScreen() {


    const [user, setUser] = useLocalStorage("user", null);
    const [type, setType] = React.useState("login");
    const { auth } = useShared();
    console.log('AuthScreen ', user);

    if (user) {
        return <Navigate to="/db/dashboard" />;
    }

    const handleTab = (txt) => {
        console.log(auth);
        setType(txt)
        auth.successMsg = null
        auth.setErrorMessage(null)
    }

    return (
        <div className={`grid place-items-center h-screen bg-red-200  bg-no-repeat bg-cover`} style={{ backgroundImage: `url(${login_bg})` }}>

            <Card className="w-full max-w-[24rem] bg-white/90 md:bg-white/70">
                <CardHeader
                    floated={false}
                    shadow={false}
                    className="m-0 grid place-items-center rounded-b-none p-2 text-center bg-main-color"
                >
                    <div className="rounded-xl border border-white/10 bg-white/10 p-2 text-white">

                        <img
                            src={logo_h}
                            alt="test"
                            className="h-20 w-[100%] bg-gray-200 border   rounded-md"
                        />
                    </div>

                </CardHeader>
                <CardBody>
                    <Tabs value={type} className="overflow-visible"
                    >
                        <TabsHeader className="relative z-0  " indicatorProps={{
                            className: "bg-main-color shadow-none text-blue-500",
                        }}>
                            <Tab value="login" className={`${type === 'login' ? 'text-white' : ''}`} onClick={() => handleTab("login")}>
                                Login
                            </Tab>
                            <Tab value="siginup" className={`${type === 'siginup' ? 'text-white' : ''}`} onClick={() => handleTab("siginup")} >
                                Create Account
                            </Tab>
                        </TabsHeader>
                        <TabsBody
                            className=""
                            animate={{
                                initial: {
                                    x: type === "login" ? 400 : -400,
                                },
                                mount: {
                                    x: 0,
                                },
                                unmount: {
                                    x: type === "login" ? 400 : -400,
                                },
                            }} >
                            <TabPanel value="login" className="p-0">
                                <Login />
                            </TabPanel>
                            <TabPanel value="siginup" className="p-0">
                                <Register />
                            </TabPanel>
                        </TabsBody>
                    </Tabs>

                    <div className="text-xs text-center mt-4 flex">
                       <h1 className="">Developed By</h1> 

                        <a href="https://web.whatsapp.com/send?phone=93702948798&text=Salaam" target="_blank" rel="noreferrer" className="text-blue-900 pl-1">Qasim Burhan Tech</a>,
                        <a href="mailto:mqburhan@gmail.com"  className="text-blue-900 pl-3">mqburhan@gmail.com</a>


                    </div>
                </CardBody>
            </Card>

            <ToastContainer />
        </div>


    );
}
